module.exports = __webpack_public_path__ + "static/img/5-2.9c3966c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-2.png
// module id = 4nrv
// module chunks = 25